import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Categories from "../../Layout/Categories/Categories";
import { Row, Col, message, Spin } from "antd";
import ScopeBar from "../../Layout/Scopes/Scopes";
import { getCategories } from "../../Categories/Application/Categories.business";
import { getCategoriesSelector } from "../../Categories/Infrastructure/Categories.reducer";
import Switch from "../../Switch/Switch";
import { getOffsets } from "../../DashboardOffset/Application/DashboardOffset.business";
import { getOffsetsSelector } from "../../DashboardOffset/Infrastructure/DashboardOffset.reducer";
import Offset from "../../DashboardOffset/Domain/DashboardOffset";
import { getSelectedOffsetYearSelector } from "../../YearsUser/Infrastructure/YearsUser.reducer";
import "./Scopes.css";


const Scopes = () => {
  const record = useSelector(getCategoriesSelector);
  const [scope, setScope] = useState("Scope 1");
  const [loading, setLoading] = useState(true);
  const [stream, setStream] = useState("upstream");
  const emissions = useSelector(getOffsetsSelector);
  const [data, setData] = useState([]);
  const offsetYear = useSelector(getSelectedOffsetYearSelector);

  const fetchData = async (params = {}) => {
    try {
      await getCategories(params);
      setLoading(false);
    } catch (error) {
      message.error("error");
    }
  };

  useEffect(() => {
    getOffsets();
  }, []);

  useEffect(() => {
    const lowerScope = scope.toLowerCase();
    let filter = { scope: lowerScope };
    if (lowerScope === "scope 3") {
      filter = { scope: lowerScope, [`${stream}`]: true };
    }
    fetchData({ filter });
  }, [scope]);

  useEffect(() => {
    if (offsetYear) {
      setLoading(true);
      fetchData().then(() => {
        setLoading(false);
      });
    }
  }, [offsetYear]);

  useEffect(() => {
    if (emissions.scopes !== undefined) {
      let scopes = emissions.scopes;
      let emissionsData = [];
      let index = 0;
      for (let key in scopes) {
        if (scopes[key].quantity !== undefined) {
          let obj = {};
          obj.id = ++index;
          obj.title = Offset.formatScopes(key);
          obj.subtitle = `${scopes[key].quantity} tons CO₂`;
          obj.percent = scopes[key].percent || 0;
          emissionsData.push(obj);
        }
      }
      setData(emissionsData);
    }
  }, [emissions]);

  const onChange = ({ target: { value } }) => {
    setLoading(true);
    setScope(value);
  };

  return (
    <div className="scopes-container">
      {loading && (
        <div className="loading-overlay">
          <Spin
            spinning={loading}
            className="spinner-container"
            tip="Loading"
            size="large"
          />
        </div>
      )}

      <div>
        {data && (
          <ScopeBar
            key={data.id}
            data={data}
            onChange={onChange}
            active={scope}
          />
        )}
        {scope && record ? (
          <Row>
            <Col span={24} className="title-container">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{display:'flex', alignItems:'center'}}>
                <span className="title-categories">Categories</span>
                <span className="categories-text">
                      {" "}
                      {Offset.formatScopes(scope)}
                    </span>
                    </div>
                {scope.includes("3") && (
                  <div style={{ marginTop: "12px" }}>
                    <Switch
                      switchLeft={"upstream"}
                      switchRight={"downstream"}
                      setStream={setStream}
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col span={24}>
              <Categories stream={stream} />
            </Col>
          </Row>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

export default Scopes;
